import React from "react"

import "../../../style/saas-setup-tab.module.css"

interface Props {
  handleCreateEnv: React.MouseEventHandler<HTMLButtonElement>
}

const DevEmptyTabSetup = (props: Props) => {

  return (
    <div className="setup-tab" style={{
        paddingRight: "1.375rem",
        paddingLeft: "1.375rem",
        paddingBottom: "1.5rem",
    }}>
      <p>
        You have not created a development environment for this app.
      </p>

      <button
        className="yellow-button yellow-button__empty-prod-tab"
        onClick={props.handleCreateEnv}
      >
        Create development env
      </button>
    </div>
  )
}

export default DevEmptyTabSetup
